/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class ReportScheduleListResponse {
    getFixupPrototypeFunction() { return ReportScheduleListResponse.fixupPrototype; }

    static newInstance(model: Partial<ReportScheduleListResponse>): ReportScheduleListResponse {
        let obj = Object.assign(new ReportScheduleListResponse(), model);
        ReportScheduleListResponse.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<ReportScheduleListResponse>): ReportScheduleListResponse {
        if (!model) return null;
        return ReportScheduleListResponse.newInstance(<ReportScheduleListResponse> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: ReportScheduleListResponse) {
        if (!obj) return;

        models.ReportScheduleListResponse.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: ReportScheduleListResponse): boolean {
        Object.setPrototypeOf(obj, ReportScheduleListResponse.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        if (this.schedules) {
            for (let val of this.schedules) {
                models.ReportScheduleSummary.fixupPrototype(val);
            }
        }
    }

    /**
     * Report schedules created by the current user
     */
    schedules: Array<models.ReportScheduleSummary>;

}
